import React from 'react';

import classes from './Arrow.scss';

import arrowImage from '../../../assets/images/long-arrow.svg';

const arrow = (props) => (
    <span {...props} className={`${classes.Arrow} u-phoneHide`}><img src={arrowImage} alt="Arrow" /></span>
);

export default arrow;


// WEBPACK FOOTER //
// ./src/components/UI/Arrow/Arrow.js